/**
 * NewInventoryIcons.jsx
 * Created by Destin Frasier on 05/23/19.
 */

import NewInventoryIconsSingleton from './newInventoryIconSingleton';
import BaseIcon from '../BaseIcon';


class NewInventoryIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = NewInventoryIconsSingleton;
    }
}

export class NewInventoryIconConnect extends NewInventoryIcon {}
NewInventoryIconConnect.defaultProps = {
    iconName: 'rec-icon-new-inventory-connect',
    iconClass: 'rec-icon-new-inventory-connect',
    alt: 'Connect With Users'
};

export class NewInventoryIconSteward extends NewInventoryIcon {}
NewInventoryIconSteward.defaultProps = {
    iconName: 'rec-icon-new-inventory-steward',
    iconClass: 'rec-icon-new-inventory-steward',
    alt: 'Steward Recreation Resources'
};

export class NewInventoryIconManage extends NewInventoryIcon {}
NewInventoryIconManage.defaultProps = {
    iconName: 'rec-icon-new-inventory-manage',
    iconClass: 'rec-icon-new-inventory-manage',
    alt: 'Manage Operations'
};

export class NewInventoryIconLotteries extends NewInventoryIcon {}
NewInventoryIconLotteries.defaultProps = {
    iconName: 'rec-icon-new-inventory-lotteries',
    iconClass: 'rec-icon-new-inventory-lotteries',
    alt: 'Lotteries'
};